"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _lodash = require("lodash");

var _constants = require("./constants");

var _Term = _interopRequireDefault(require("./Term"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var Range = /*#__PURE__*/function () {
  /**
   * A range indicates a value associated with a period of time
   * bound by two numbers, start and end.
   * It's invalid if either of those values are not numbers,
   * or if they are not in order.
   *
   * Name can be anything including a word index.
   * @param params
   */
  function Range(params) {
    Object.assign(this, params);
  }

  var _proto = Range.prototype;

  _proto.placeOf = function placeOf(t) {
    if (!this.isValid) return null;
    if (!(0, _lodash.isNumber)(t)) return null;
    if (t <= this.start) return t - this.start;
    if (t >= this.end) return this.end - t;
    return 0;
  };

  _proto.intersects = function intersects(term) {
    if (!(this.isValid && term instanceof _Term["default"] && term.isValidTime)) {
      return false;
    }

    return this.start < term.end && this.end >= term.start;
  };

  _createClass(Range, [{
    key: "name",
    get: function get() {
      return this._name || _constants.DEFAULT_RANGE;
    },
    set: function set(name) {
      this._name = name;
    }
  }, {
    key: "start",
    get: function get() {
      return (0, _lodash.isNumber)(this._start) ? this._start : null;
    },
    set: function set(value) {
      this._start = value;
    }
  }, {
    key: "end",
    get: function get() {
      return (0, _lodash.isNumber)(this._end) ? this._end : null;
    },
    set: function set(value) {
      this._end = value;
    }
  }, {
    key: "mid",
    get: function get() {
      if (!this.isValid) return null;
      return (0, _lodash.mean)([this.start, this.end]);
    }
  }, {
    key: "isValid",
    get: function get() {
      return (0, _lodash.isNumber)(this.start) && (0, _lodash.isNumber)(this.end) && this.start <= this.end;
    }
  }]);

  return Range;
}();
/**
 * finds the nearest range in a series of ranges, given a time t
 * the assumption is that the ranges may NOT be contiguous, or even
 * necessarily, in order
 * @param ranges {Range}
 * @param t
 * @param trust
 * @returns {*}
 */


Range.nearestRange = function (ranges, t, trust) {
  var validRanges;
  if (trust) validRanges = ranges;else {
    if (!(0, _lodash.isNumber)(t)) throw new Error('non-numeric index search for time');
    validRanges = ranges.filter(function (r) {
      return r instanceof Range && r.isValid;
    });
  }
  var found = false;
  var nearest = null;
  var nearestDist = Number.MAX_VALUE;
  validRanges.forEach(function (range) {
    if (found) return;
    var dist = range.placeOf(t);
    found = !dist;

    if (found) {
      nearest = range;
    } else {
      var absDist = Math.abs(dist);

      if (!nearest || absDist < nearestDist) {
        nearestDist = absDist;
        nearest = range;
      }
    }
  });
  return {
    nearest: nearest,
    nearestDist: nearestDist,
    found: found
  };
};

var _default = Range;
exports["default"] = _default;